import React from "react";
import styled from "styled-components";

const StyledPlusMinus = styled.div`
  & > div {
    width: 1.5rem;
    height: 2px;
    line-height: 0;
  }
  .fade {
    position: relative;
    bottom: 1px;
  }
  &.open {
    .rotate {
      transform: rotate(0deg);
      transition: all .3s ease;
    }
    .fade {
        opacity: 0;
        transition: all .3s ease;
    }
  }
  &.shut {
    .rotate {
      transform: rotate(90deg);
      transition: all .3s ease;
    }
    .fade {
        opacity: 1;
        transition: all .3s ease;
    }
  }
`;

export const PlusMinus = ({ isOpen, plusStyle, style }) => {
  const _style = style ? { ...plusStyle } : { background: "black" };
  return (
    <StyledPlusMinus className={isOpen ? "open" : "shut"} style={style}>
      <div className="rotate" style={_style}></div>
      <div className="fade" style={_style}></div>
    </StyledPlusMinus>
  );
};
